import { Col, Form, Pagination, Row } from 'react-bootstrap';

// Same pagination-wrapper markup as /support (SupportList), client-side.
const CommunityPaginationRow = ({
    total,
    currentPage,
    totalPages,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
}) => (
    <Row className="pagination-wrapper">
        <Col className="d-flex align-items-center">
            <span>Total&nbsp;{total}&nbsp;{total === 1 ? 'community' : 'communities'}</span>
            <Pagination>
                <Pagination.Prev
                    onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                    disabled={currentPage === 1}
                />
                {[...Array(totalPages).keys()].map((number) => (
                    <Pagination.Item
                        key={number + 1}
                        active={number + 1 === currentPage}
                        onClick={() => onPageChange(number + 1)}
                    >
                        {number + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next
                    onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                    disabled={currentPage === totalPages}
                />
            </Pagination>
        </Col>
        <Col className="pagination-controls">
            <div className="pagination-controls-per-page">
                <Form.Select
                    value={rowsPerPage}
                    onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
                    style={{ width: 'auto', marginRight: '10px' }}
                >
                    <option value="10">10 / page</option>
                    <option value="20">20 / page</option>
                    <option value="40">40 / page</option>
                </Form.Select>
            </div>
            <label className="pagination-controls-goto-label" htmlFor="goto-page-communities">Go to</label>
            <Form.Control
                id="goto-page-communities"
                type="number"
                className="pagination-controls-goto-input"
                value={currentPage}
                onChange={(e) => {
                    const p = Number(e.target.value);
                    if (p >= 1 && p <= totalPages) onPageChange(p);
                }}
                style={{ textAlign: 'center' }}
            />
        </Col>
    </Row>
);

export default CommunityPaginationRow;
